import React from 'react'

const OfferCreationPage = () => {
  return <h1>Offer creation</h1>
}

export default OfferCreationPage
